import * as types from '../types/authTypes';

export const signOutRequest = () => ({
    type: types.SIGNOUT_REQUEST,
});

